import {useCategories} from "../hooks/useCategories";
import Loader from "./Loader";
import usePaperlessNavigate from "../hooks/usePaperlessNavigate";
import {createFormAtom} from "../atoms/createFormAtom";
import {useAtom} from "jotai";
import Card from "./Card";
import NetworkError from "./NetworkError";
import {useMemo} from "react";

const Categories = () => {
    const {data, isError, error, isLoading, isSuccess} = useCategories()
    const {paperlessNavigate} = usePaperlessNavigate();
    const [formAtom, setFormAtom] = useAtom(createFormAtom);

    const activeCategories = useMemo(() => data?.filter(c => c.activeStatus), [data])

    const handleNavigation = (category) => {
        setFormAtom({
            ...formAtom,
            categoryId: category.categoryId
        })
        paperlessNavigate(
            {
                destination: `/forms/${category.categoryId}`,
                payload: category.categoryName
            })
    }


    if (isError && error.code === 'ERR_NETWORK') {
        return (
            <NetworkError error={error}/>
        )
    }

    return (
        <>
            <p className={'page-title'}>Categories</p>
            {isSuccess && <div className={'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7 px-8'}>
                {activeCategories.map((c, i) =>
                    <button type={'button'} key={i} className={'block'}
                            onClick={() => handleNavigation(c)}>
                        <Card title={c.categoryName} description={c.description}/>
                    </button>
                )}
            </div>}
            {isLoading && !isError && <Loader className={'fixed inset-0'}/>}
        </>
    )
};

export default Categories;